import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { ChevronLeft } from "lucide-react"
import { BillingLogs } from "../../types"
import {
  useFetchOrgDetailsQuery,
  useFetchOrgSystemUsageQuery
} from "../../redux/queries"
import { If, LightBtn, PageHeader } from "../../common/ui"
import { ListSkeleton } from "../../common/ui/skeletons"
import { InvoicesTable } from "../../common/ui/billing-table"
import { CustomPagination } from "../../common/ui/pagination"
import { RequireRole } from "../../common/validation"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"

let month = ""

const BillingOrgInvoices = () => {
  const { org_id = "" } = useParams<{ org_id: string }>()
  const navigate = useNavigate()

  const [currentPageInvoices, setCurrentPageInvoices] = useState<BillingLogs>(
    []
  )

  const { data: orgDetails, isFetching: isFetchingOrg } =
    useFetchOrgDetailsQuery({ id: org_id }, { skip: !org_id })

  const {
    data: systemUsage = [],
    isFetching: isFetchingUsage,
    isError: isErrorUsage
  } = useFetchOrgSystemUsageQuery({ orgId: org_id, month }, { skip: !org_id })

  const onClickBack = () => {
    navigate("/billing")
  }

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE.billing}>
      <>
        <div className="p-6 pt-4 sm:pt-6 border-neutral-200">
          <PageHeader title={`Billing: ${orgDetails?.name ?? ""}`}>
            <LightBtn onClick={onClickBack} text="base" size="sm">
              <ChevronLeft size={16} />
              <span className="inline-block px-1">Back</span>
            </LightBtn>
          </PageHeader>
        </div>
        <div className="px-4 py-6 md:px-6 flex-1 bg-primary-100">
          {isErrorUsage && <p>Failed to load data.</p>}
          <If
            condition={(isFetchingOrg || isFetchingUsage) && !isErrorUsage}
            then={
              <ListSkeleton containerClassName="rounded-lg overflow-hidden" />
            }
            else={
              <>
                <InvoicesTable
                  orgId={org_id}
                  systemUsage={currentPageInvoices}
                  invoicePath="billing"
                />
                <CustomPagination<BillingLogs>
                  items={systemUsage}
                  updateDisplayedItems={setCurrentPageInvoices}
                />
              </>
            }
          />
        </div>
      </>
    </RequireRole>
  )
}

export default BillingOrgInvoices
